import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import Header from './components/Header';
import Home from './components/Home';
import Seasons from './components/Seasons';
import AddWager from './components/AddWager';
import Goat from './components/Goat';
import Line from './components/Line';
import Wager from './components/Wager';

import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

// NOTE: Amplify.configure(...) now lives in src/index.js

function App() {
  return (
    <div>
      <Header />
      <Router>
        <div className="link1">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/components/Home" component={Home} />
            <Route exact path="/components/Seasons" component={Seasons} />
            <Route exact path="/components/Goat" component={Goat} />
            <Route exact path="/components/Line" component={Line} />
            <Route exact path="/components/Wager" component={Wager} />
            <Route exact path="/components/AddWager" component={AddWager} />
          </Switch>
        </div>
      </Router>
    </div>
  );
}

// Old MyTheme (from aws-amplify-react) isn't used by the new UI library.
// Use ThemeProvider / tokens if you want to theme later.
export default withAuthenticator(App);

